import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import { settings } from "../../../../../redux/settings/actions";
import UploadCommonModal from "../../../../../models/upload-common-modal";
import { toast } from "react-toastify";
import { globalEANs } from "../../../../../redux/global-eans/action";
import { selectGlobalEANsListItems } from "../../../../../redux/global-eans/selector";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const GlobalEANS = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const { getUploadModal } = useAppSelector(selectCurrent)
  const globalEANSListItems = useSelector(selectGlobalEANsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'EANs', headerName: 'EANs', searchField: 'EANs', filter: true, filterType: 'text' },
      { field: 'Description', headerName: 'Description' }
    ]);
  }

  const fetchGlobalEANList = async () => {
    await dispatch(globalEANs.resetAction({ actionType: 'list' }))
    await dispatch(globalEANs.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans/fetch`,
      entity: 'globalEANs',
      jsonData:
      {
        Context: {},
        Records: [{}],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",
        }
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data.Id}`)
  }

  useEffect(() => {
    createColumnDefs();
    fetchGlobalEANList();
  }, [pageData, pageSize])

  const additionButtons: any = [
    // {
    //   name: 'Add Global EAN',
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Import Global EAN</title>
          <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleUploadGlobalEANClick(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
          <title>Download Template</title>
          <path d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleDownloadTemplate(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchGlobalEANList();
  }

  const handleUploadGlobalEANClick = () => {
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = async (data: any) => {
    await dispatch(globalEANs.resetAction({ actionType: 'delete' }))
    await dispatch(globalEANs.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans/delete`,
      entity: 'globalEANs',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchGlobalEANList();
    });
  }

  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(globalEANs.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(globalEANs.uploadCreate({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans/upload`,
      entity: 'uploadEAN',
      jsonData:
        frmData
    })).then(() => {
      toast.info(
        'Gloabal EAN uploading is in progress...',
      );
      handleUploadClose()
    }).then(() => {
      fetchGlobalEANList();
    })
  };

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(globalEANs.resetAction({ actionType: 'list' }))
    await dispatch(globalEANs.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans/fetch`,
      entity: 'globalEANs',
      jsonData: {
        Context: {},
        Records: [{}],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",
          Searches: searchCriteria,
        },
      }
    }))
  }

  const handleDownloadTemplate = () => {
    const fileUrl = require('../../../../../assets/data/ean-template.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "ean-template.csv"); // Optional: Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {getUploadModal == 'open' && <UploadCommonModal title='Upload Global EAN' onSubmit={handleUploadClick} handleClose={handleUploadClose} />}
      {globalEANSListItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={globalEANSListItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={globalEANSListItems?.result?.pagination}
          enableFilter={true}
          onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          headingName="Global EAN"
        />
      }
    </>
  );
};

export default GlobalEANS;


